export function isLastConnectionMessage(connection, connections) {
  return isLastConnection(connection, connections)
    ? `Are you sure you want to disable the integration for your current location? This will also deactivate any automations added by the integration. You can re-enable it at any time.`
    : `Are you sure you want to disable this connection? This will prevent any patients being created with this doctors connection. You can re-enable it at any time.`
}

export function isLastConnectionHeading(connection, connections) {
  return isLastConnection(connection, connections)
    ? `Disable integration?`
    : `Disable connection?`
}

export function isLastConnection(connection, connections) {
  let maybeConnectionActive = connections.filter(
    c => c.id !== connection.id && c.status === 'active'
  )
  return maybeConnectionActive && maybeConnectionActive?.length === 0
}
